// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: jobs_interface.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { GenerateAnalysisTree_Request } from "./interface";
import { FilterProto, Header } from "./metadata";

export const protobufPackage = "com.meritic.newton";

/** Representation of a job request. */
export interface JobRequest {
  global_properties?:
    | JobRequest_GlobalProperties
    | undefined;
  /** List of requests to generate tree and what actions to take on them. */
  analysis_action_requests: AnalysisActionRequest[];
  /** List of actions associated to this job. */
  actions: ActionRequest[];
}

export interface JobRequest_GlobalProperties {
  /** Filters to be applied in each analysis request. */
  context_filters: FilterProto[];
  /** Create new report book if name is given, and use it for AssignPage action. */
  report_book_name?:
    | string
    | undefined;
  /** Find existing report book if id is given, and use it for AssignPage action */
  report_book_id?: string | undefined;
}

/** Request to generate analysis tree and actions to take on it. */
export interface AnalysisActionRequest {
  /** Either analysis_plan or generate_tree_request will be set. */
  generate_tree_request?: GenerateAnalysisTree_Request | undefined;
  analysis_plan_header?:
    | Header
    | undefined;
  /** @Deprecated: Actions have moved to the job request. */
  actions: ActionRequest[];
  analysis_step_name?: string | undefined;
  step_id?: string | undefined;
}

/** Representation of an action to be taken on analysis tree. */
export interface ActionRequest {
  step_id?:
    | string
    | undefined;
  /** One of the requests is set, based on the action type. */
  type?:
    | ActionRequest_ActionType
    | undefined;
  /** Ids of parent actions or analysis plans which will be used as inputs to action. */
  parent_ids: string[];
  generate_commentary_request?: GenerateCommentaryActionRequest | undefined;
  assign_to_page_request?: AssignToPageActionRequest | undefined;
  notify_slack_request?: NotifySlackActionRequest | undefined;
  qna_request?: QnARequest | undefined;
}

/** Type of action. */
export enum ActionRequest_ActionType {
  INVALID_ACTION = 0,
  GENERATE_COMMENTARY = 1,
  ASSIGN_TO_PAGE = 2,
  NOTIFY_SLACK = 3,
  QNA = 4,
  UNRECOGNIZED = -1,
}

export function actionRequest_ActionTypeFromJSON(object: any): ActionRequest_ActionType {
  switch (object) {
    case 0:
    case "INVALID_ACTION":
      return ActionRequest_ActionType.INVALID_ACTION;
    case 1:
    case "GENERATE_COMMENTARY":
      return ActionRequest_ActionType.GENERATE_COMMENTARY;
    case 2:
    case "ASSIGN_TO_PAGE":
      return ActionRequest_ActionType.ASSIGN_TO_PAGE;
    case 3:
    case "NOTIFY_SLACK":
      return ActionRequest_ActionType.NOTIFY_SLACK;
    case 4:
    case "QNA":
      return ActionRequest_ActionType.QNA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ActionRequest_ActionType.UNRECOGNIZED;
  }
}

export function actionRequest_ActionTypeToJSON(object: ActionRequest_ActionType): string {
  switch (object) {
    case ActionRequest_ActionType.INVALID_ACTION:
      return "INVALID_ACTION";
    case ActionRequest_ActionType.GENERATE_COMMENTARY:
      return "GENERATE_COMMENTARY";
    case ActionRequest_ActionType.ASSIGN_TO_PAGE:
      return "ASSIGN_TO_PAGE";
    case ActionRequest_ActionType.NOTIFY_SLACK:
      return "NOTIFY_SLACK";
    case ActionRequest_ActionType.QNA:
      return "QNA";
    case ActionRequest_ActionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Request to generate commentary for the tree. */
export interface GenerateCommentaryActionRequest {
  /** Nodes selected to generate commentary. */
  selected_nodes: GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId[];
}

export interface GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
  /** Id of the benchmark in whose subtree the node lies. */
  benchmark_id?:
    | string
    | undefined;
  /** Destination id of the MKG edge used to create the subtree node. */
  edge_destination_id?: string | undefined;
}

/** Request to assign tree to a report page. */
export interface AssignToPageActionRequest {
  page_name?: string | undefined;
  book_id?: string | undefined;
}

/** Request to notify the insights on slack. */
export interface NotifySlackActionRequest {
  channel_ids: string[];
}

/** Request for QnA action. */
export interface QnARequest {
  questions: string[];
}

/** Representation of a job. */
export interface JobProto {
  /** Header of job. */
  header?:
    | Header
    | undefined;
  /** Job request to execute the job. */
  request?:
    | JobRequest
    | undefined;
  /** Header of the runs associated with this job. */
  job_run_headers: Header[];
}

/** Representation of job run. */
export interface JobRunProto {
  /** Header of job run. */
  header?:
    | Header
    | undefined;
  /** Header of the job. */
  job_header?:
    | Header
    | undefined;
  /** List of steps in this job run. */
  steps: JobRunStep[];
  /** List of actions in this job run. */
  actions: JobRunStep[];
}

/** Representation of job run step. */
export interface JobRunStep {
  /** Index of the analysis step in the job request. */
  analysis_step_index?:
    | number
    | undefined;
  /** Index of this step in steps array */
  db_content_index?:
    | number
    | undefined;
  /** Id of the step. */
  id?:
    | string
    | undefined;
  /** Type of step. */
  type?:
    | JobRunStep_StepType
    | undefined;
  /** Name of step. */
  name?:
    | string
    | undefined;
  /** TreeIds associated to this action, will be set only if step if of type action. */
  input_tree_ids: string[];
  /** Based on step type, one of the requests will be populated. */
  analysis_step?: GenerateAnalysisTree_Request | undefined;
  analysis_plan_header?: Header | undefined;
  action_step?:
    | ActionRequest
    | undefined;
  /** current execution status of the step. */
  status?:
    | JobRunStep_RunStepStatus
    | undefined;
  /** Start time of the step in milliseconds. */
  start_time_ms?:
    | number
    | undefined;
  /** End time of the step in milliseconds. */
  end_time_ms?:
    | number
    | undefined;
  /** error in execution of step. */
  error?:
    | string
    | undefined;
  /** output generated by the step. */
  output?: string | undefined;
}

/** Type of step. */
export enum JobRunStep_StepType {
  INVALID_STEP = 0,
  ANALYSIS_STEP = 1,
  ACTION_STEP = 2,
  UNRECOGNIZED = -1,
}

export function jobRunStep_StepTypeFromJSON(object: any): JobRunStep_StepType {
  switch (object) {
    case 0:
    case "INVALID_STEP":
      return JobRunStep_StepType.INVALID_STEP;
    case 1:
    case "ANALYSIS_STEP":
      return JobRunStep_StepType.ANALYSIS_STEP;
    case 2:
    case "ACTION_STEP":
      return JobRunStep_StepType.ACTION_STEP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobRunStep_StepType.UNRECOGNIZED;
  }
}

export function jobRunStep_StepTypeToJSON(object: JobRunStep_StepType): string {
  switch (object) {
    case JobRunStep_StepType.INVALID_STEP:
      return "INVALID_STEP";
    case JobRunStep_StepType.ANALYSIS_STEP:
      return "ANALYSIS_STEP";
    case JobRunStep_StepType.ACTION_STEP:
      return "ACTION_STEP";
    case JobRunStep_StepType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Execution status of the job run step. */
export enum JobRunStep_RunStepStatus {
  /** PENDING - Step not started executing yet. */
  PENDING = 0,
  /** IN_PROGRESS - Step execution in progress. */
  IN_PROGRESS = 1,
  /** SUCCESS - Step execution finished successfully. */
  SUCCESS = 2,
  /** FAILURE - Step execution failed. */
  FAILURE = 3,
  UNRECOGNIZED = -1,
}

export function jobRunStep_RunStepStatusFromJSON(object: any): JobRunStep_RunStepStatus {
  switch (object) {
    case 0:
    case "PENDING":
      return JobRunStep_RunStepStatus.PENDING;
    case 1:
    case "IN_PROGRESS":
      return JobRunStep_RunStepStatus.IN_PROGRESS;
    case 2:
    case "SUCCESS":
      return JobRunStep_RunStepStatus.SUCCESS;
    case 3:
    case "FAILURE":
      return JobRunStep_RunStepStatus.FAILURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobRunStep_RunStepStatus.UNRECOGNIZED;
  }
}

export function jobRunStep_RunStepStatusToJSON(object: JobRunStep_RunStepStatus): string {
  switch (object) {
    case JobRunStep_RunStepStatus.PENDING:
      return "PENDING";
    case JobRunStep_RunStepStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case JobRunStep_RunStepStatus.SUCCESS:
      return "SUCCESS";
    case JobRunStep_RunStepStatus.FAILURE:
      return "FAILURE";
    case JobRunStep_RunStepStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseJobRequest(): JobRequest {
  return { global_properties: undefined, analysis_action_requests: [], actions: [] };
}

export const JobRequest: MessageFns<JobRequest> = {
  encode(message: JobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.global_properties !== undefined) {
      JobRequest_GlobalProperties.encode(message.global_properties, writer.uint32(10).fork()).join();
    }
    for (const v of message.analysis_action_requests) {
      AnalysisActionRequest.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.actions) {
      ActionRequest.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.global_properties = JobRequest_GlobalProperties.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.analysis_action_requests.push(AnalysisActionRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.actions.push(ActionRequest.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobRequest {
    return {
      global_properties: isSet(object.global_properties)
        ? JobRequest_GlobalProperties.fromJSON(object.global_properties)
        : undefined,
      analysis_action_requests: globalThis.Array.isArray(object?.analysis_action_requests)
        ? object.analysis_action_requests.map((e: any) => AnalysisActionRequest.fromJSON(e))
        : [],
      actions: globalThis.Array.isArray(object?.actions)
        ? object.actions.map((e: any) => ActionRequest.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JobRequest): unknown {
    const obj: any = {};
    if (message.global_properties !== undefined) {
      obj.global_properties = JobRequest_GlobalProperties.toJSON(message.global_properties);
    }
    if (message.analysis_action_requests?.length) {
      obj.analysis_action_requests = message.analysis_action_requests.map((e) => AnalysisActionRequest.toJSON(e));
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => ActionRequest.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobRequest>, I>>(base?: I): JobRequest {
    return JobRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobRequest>, I>>(object: I): JobRequest {
    const message = createBaseJobRequest();
    message.global_properties = (object.global_properties !== undefined && object.global_properties !== null)
      ? JobRequest_GlobalProperties.fromPartial(object.global_properties)
      : undefined;
    message.analysis_action_requests =
      object.analysis_action_requests?.map((e) => AnalysisActionRequest.fromPartial(e)) || [];
    message.actions = object.actions?.map((e) => ActionRequest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJobRequest_GlobalProperties(): JobRequest_GlobalProperties {
  return { context_filters: [], report_book_name: undefined, report_book_id: undefined };
}

export const JobRequest_GlobalProperties: MessageFns<JobRequest_GlobalProperties> = {
  encode(message: JobRequest_GlobalProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.context_filters) {
      FilterProto.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.report_book_name !== undefined) {
      writer.uint32(18).string(message.report_book_name);
    }
    if (message.report_book_id !== undefined) {
      writer.uint32(26).string(message.report_book_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobRequest_GlobalProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobRequest_GlobalProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.context_filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.report_book_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.report_book_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobRequest_GlobalProperties {
    return {
      context_filters: globalThis.Array.isArray(object?.context_filters)
        ? object.context_filters.map((e: any) => FilterProto.fromJSON(e))
        : [],
      report_book_name: isSet(object.report_book_name) ? globalThis.String(object.report_book_name) : undefined,
      report_book_id: isSet(object.report_book_id) ? globalThis.String(object.report_book_id) : undefined,
    };
  },

  toJSON(message: JobRequest_GlobalProperties): unknown {
    const obj: any = {};
    if (message.context_filters?.length) {
      obj.context_filters = message.context_filters.map((e) => FilterProto.toJSON(e));
    }
    if (message.report_book_name !== undefined) {
      obj.report_book_name = message.report_book_name;
    }
    if (message.report_book_id !== undefined) {
      obj.report_book_id = message.report_book_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobRequest_GlobalProperties>, I>>(base?: I): JobRequest_GlobalProperties {
    return JobRequest_GlobalProperties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobRequest_GlobalProperties>, I>>(object: I): JobRequest_GlobalProperties {
    const message = createBaseJobRequest_GlobalProperties();
    message.context_filters = object.context_filters?.map((e) => FilterProto.fromPartial(e)) || [];
    message.report_book_name = object.report_book_name ?? undefined;
    message.report_book_id = object.report_book_id ?? undefined;
    return message;
  },
};

function createBaseAnalysisActionRequest(): AnalysisActionRequest {
  return {
    generate_tree_request: undefined,
    analysis_plan_header: undefined,
    actions: [],
    analysis_step_name: undefined,
    step_id: undefined,
  };
}

export const AnalysisActionRequest: MessageFns<AnalysisActionRequest> = {
  encode(message: AnalysisActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.generate_tree_request !== undefined) {
      GenerateAnalysisTree_Request.encode(message.generate_tree_request, writer.uint32(10).fork()).join();
    }
    if (message.analysis_plan_header !== undefined) {
      Header.encode(message.analysis_plan_header, writer.uint32(18).fork()).join();
    }
    for (const v of message.actions) {
      ActionRequest.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.analysis_step_name !== undefined) {
      writer.uint32(34).string(message.analysis_step_name);
    }
    if (message.step_id !== undefined) {
      writer.uint32(42).string(message.step_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalysisActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalysisActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.generate_tree_request = GenerateAnalysisTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.analysis_plan_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.actions.push(ActionRequest.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analysis_step_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.step_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalysisActionRequest {
    return {
      generate_tree_request: isSet(object.generate_tree_request)
        ? GenerateAnalysisTree_Request.fromJSON(object.generate_tree_request)
        : undefined,
      analysis_plan_header: isSet(object.analysis_plan_header)
        ? Header.fromJSON(object.analysis_plan_header)
        : undefined,
      actions: globalThis.Array.isArray(object?.actions)
        ? object.actions.map((e: any) => ActionRequest.fromJSON(e))
        : [],
      analysis_step_name: isSet(object.analysis_step_name) ? globalThis.String(object.analysis_step_name) : undefined,
      step_id: isSet(object.step_id) ? globalThis.String(object.step_id) : undefined,
    };
  },

  toJSON(message: AnalysisActionRequest): unknown {
    const obj: any = {};
    if (message.generate_tree_request !== undefined) {
      obj.generate_tree_request = GenerateAnalysisTree_Request.toJSON(message.generate_tree_request);
    }
    if (message.analysis_plan_header !== undefined) {
      obj.analysis_plan_header = Header.toJSON(message.analysis_plan_header);
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => ActionRequest.toJSON(e));
    }
    if (message.analysis_step_name !== undefined) {
      obj.analysis_step_name = message.analysis_step_name;
    }
    if (message.step_id !== undefined) {
      obj.step_id = message.step_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalysisActionRequest>, I>>(base?: I): AnalysisActionRequest {
    return AnalysisActionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalysisActionRequest>, I>>(object: I): AnalysisActionRequest {
    const message = createBaseAnalysisActionRequest();
    message.generate_tree_request =
      (object.generate_tree_request !== undefined && object.generate_tree_request !== null)
        ? GenerateAnalysisTree_Request.fromPartial(object.generate_tree_request)
        : undefined;
    message.analysis_plan_header = (object.analysis_plan_header !== undefined && object.analysis_plan_header !== null)
      ? Header.fromPartial(object.analysis_plan_header)
      : undefined;
    message.actions = object.actions?.map((e) => ActionRequest.fromPartial(e)) || [];
    message.analysis_step_name = object.analysis_step_name ?? undefined;
    message.step_id = object.step_id ?? undefined;
    return message;
  },
};

function createBaseActionRequest(): ActionRequest {
  return {
    step_id: undefined,
    type: undefined,
    parent_ids: [],
    generate_commentary_request: undefined,
    assign_to_page_request: undefined,
    notify_slack_request: undefined,
    qna_request: undefined,
  };
}

export const ActionRequest: MessageFns<ActionRequest> = {
  encode(message: ActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.step_id !== undefined) {
      writer.uint32(10).string(message.step_id);
    }
    if (message.type !== undefined) {
      writer.uint32(16).int32(message.type);
    }
    for (const v of message.parent_ids) {
      writer.uint32(26).string(v!);
    }
    if (message.generate_commentary_request !== undefined) {
      GenerateCommentaryActionRequest.encode(message.generate_commentary_request, writer.uint32(34).fork()).join();
    }
    if (message.assign_to_page_request !== undefined) {
      AssignToPageActionRequest.encode(message.assign_to_page_request, writer.uint32(42).fork()).join();
    }
    if (message.notify_slack_request !== undefined) {
      NotifySlackActionRequest.encode(message.notify_slack_request, writer.uint32(50).fork()).join();
    }
    if (message.qna_request !== undefined) {
      QnARequest.encode(message.qna_request, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.step_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parent_ids.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.generate_commentary_request = GenerateCommentaryActionRequest.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.assign_to_page_request = AssignToPageActionRequest.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.notify_slack_request = NotifySlackActionRequest.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.qna_request = QnARequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActionRequest {
    return {
      step_id: isSet(object.step_id) ? globalThis.String(object.step_id) : undefined,
      type: isSet(object.type) ? actionRequest_ActionTypeFromJSON(object.type) : undefined,
      parent_ids: globalThis.Array.isArray(object?.parent_ids)
        ? object.parent_ids.map((e: any) => globalThis.String(e))
        : [],
      generate_commentary_request: isSet(object.generate_commentary_request)
        ? GenerateCommentaryActionRequest.fromJSON(object.generate_commentary_request)
        : undefined,
      assign_to_page_request: isSet(object.assign_to_page_request)
        ? AssignToPageActionRequest.fromJSON(object.assign_to_page_request)
        : undefined,
      notify_slack_request: isSet(object.notify_slack_request)
        ? NotifySlackActionRequest.fromJSON(object.notify_slack_request)
        : undefined,
      qna_request: isSet(object.qna_request) ? QnARequest.fromJSON(object.qna_request) : undefined,
    };
  },

  toJSON(message: ActionRequest): unknown {
    const obj: any = {};
    if (message.step_id !== undefined) {
      obj.step_id = message.step_id;
    }
    if (message.type !== undefined) {
      obj.type = actionRequest_ActionTypeToJSON(message.type);
    }
    if (message.parent_ids?.length) {
      obj.parent_ids = message.parent_ids;
    }
    if (message.generate_commentary_request !== undefined) {
      obj.generate_commentary_request = GenerateCommentaryActionRequest.toJSON(message.generate_commentary_request);
    }
    if (message.assign_to_page_request !== undefined) {
      obj.assign_to_page_request = AssignToPageActionRequest.toJSON(message.assign_to_page_request);
    }
    if (message.notify_slack_request !== undefined) {
      obj.notify_slack_request = NotifySlackActionRequest.toJSON(message.notify_slack_request);
    }
    if (message.qna_request !== undefined) {
      obj.qna_request = QnARequest.toJSON(message.qna_request);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActionRequest>, I>>(base?: I): ActionRequest {
    return ActionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActionRequest>, I>>(object: I): ActionRequest {
    const message = createBaseActionRequest();
    message.step_id = object.step_id ?? undefined;
    message.type = object.type ?? undefined;
    message.parent_ids = object.parent_ids?.map((e) => e) || [];
    message.generate_commentary_request =
      (object.generate_commentary_request !== undefined && object.generate_commentary_request !== null)
        ? GenerateCommentaryActionRequest.fromPartial(object.generate_commentary_request)
        : undefined;
    message.assign_to_page_request =
      (object.assign_to_page_request !== undefined && object.assign_to_page_request !== null)
        ? AssignToPageActionRequest.fromPartial(object.assign_to_page_request)
        : undefined;
    message.notify_slack_request = (object.notify_slack_request !== undefined && object.notify_slack_request !== null)
      ? NotifySlackActionRequest.fromPartial(object.notify_slack_request)
      : undefined;
    message.qna_request = (object.qna_request !== undefined && object.qna_request !== null)
      ? QnARequest.fromPartial(object.qna_request)
      : undefined;
    return message;
  },
};

function createBaseGenerateCommentaryActionRequest(): GenerateCommentaryActionRequest {
  return { selected_nodes: [] };
}

export const GenerateCommentaryActionRequest: MessageFns<GenerateCommentaryActionRequest> = {
  encode(message: GenerateCommentaryActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.selected_nodes) {
      GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCommentaryActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCommentaryActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.selected_nodes.push(
            GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.decode(reader, reader.uint32()),
          );
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCommentaryActionRequest {
    return {
      selected_nodes: globalThis.Array.isArray(object?.selected_nodes)
        ? object.selected_nodes.map((e: any) => GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenerateCommentaryActionRequest): unknown {
    const obj: any = {};
    if (message.selected_nodes?.length) {
      obj.selected_nodes = message.selected_nodes.map((e) =>
        GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCommentaryActionRequest>, I>>(base?: I): GenerateCommentaryActionRequest {
    return GenerateCommentaryActionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCommentaryActionRequest>, I>>(
    object: I,
  ): GenerateCommentaryActionRequest {
    const message = createBaseGenerateCommentaryActionRequest();
    message.selected_nodes =
      object.selected_nodes?.map((e) => GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenerateCommentaryActionRequest_BenchmarkSubtreeNodeId(): GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
  return { benchmark_id: undefined, edge_destination_id: undefined };
}

export const GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId: MessageFns<
  GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId
> = {
  encode(
    message: GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.benchmark_id !== undefined) {
      writer.uint32(10).string(message.benchmark_id);
    }
    if (message.edge_destination_id !== undefined) {
      writer.uint32(18).string(message.edge_destination_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCommentaryActionRequest_BenchmarkSubtreeNodeId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.benchmark_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edge_destination_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
    return {
      benchmark_id: isSet(object.benchmark_id) ? globalThis.String(object.benchmark_id) : undefined,
      edge_destination_id: isSet(object.edge_destination_id)
        ? globalThis.String(object.edge_destination_id)
        : undefined,
    };
  },

  toJSON(message: GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId): unknown {
    const obj: any = {};
    if (message.benchmark_id !== undefined) {
      obj.benchmark_id = message.benchmark_id;
    }
    if (message.edge_destination_id !== undefined) {
      obj.edge_destination_id = message.edge_destination_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId>, I>>(
    base?: I,
  ): GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
    return GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId>, I>>(
    object: I,
  ): GenerateCommentaryActionRequest_BenchmarkSubtreeNodeId {
    const message = createBaseGenerateCommentaryActionRequest_BenchmarkSubtreeNodeId();
    message.benchmark_id = object.benchmark_id ?? undefined;
    message.edge_destination_id = object.edge_destination_id ?? undefined;
    return message;
  },
};

function createBaseAssignToPageActionRequest(): AssignToPageActionRequest {
  return { page_name: undefined, book_id: undefined };
}

export const AssignToPageActionRequest: MessageFns<AssignToPageActionRequest> = {
  encode(message: AssignToPageActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.page_name !== undefined) {
      writer.uint32(10).string(message.page_name);
    }
    if (message.book_id !== undefined) {
      writer.uint32(18).string(message.book_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignToPageActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignToPageActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.page_name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.book_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignToPageActionRequest {
    return {
      page_name: isSet(object.page_name) ? globalThis.String(object.page_name) : undefined,
      book_id: isSet(object.book_id) ? globalThis.String(object.book_id) : undefined,
    };
  },

  toJSON(message: AssignToPageActionRequest): unknown {
    const obj: any = {};
    if (message.page_name !== undefined) {
      obj.page_name = message.page_name;
    }
    if (message.book_id !== undefined) {
      obj.book_id = message.book_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignToPageActionRequest>, I>>(base?: I): AssignToPageActionRequest {
    return AssignToPageActionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignToPageActionRequest>, I>>(object: I): AssignToPageActionRequest {
    const message = createBaseAssignToPageActionRequest();
    message.page_name = object.page_name ?? undefined;
    message.book_id = object.book_id ?? undefined;
    return message;
  },
};

function createBaseNotifySlackActionRequest(): NotifySlackActionRequest {
  return { channel_ids: [] };
}

export const NotifySlackActionRequest: MessageFns<NotifySlackActionRequest> = {
  encode(message: NotifySlackActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channel_ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotifySlackActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotifySlackActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.channel_ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotifySlackActionRequest {
    return {
      channel_ids: globalThis.Array.isArray(object?.channel_ids)
        ? object.channel_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: NotifySlackActionRequest): unknown {
    const obj: any = {};
    if (message.channel_ids?.length) {
      obj.channel_ids = message.channel_ids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotifySlackActionRequest>, I>>(base?: I): NotifySlackActionRequest {
    return NotifySlackActionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotifySlackActionRequest>, I>>(object: I): NotifySlackActionRequest {
    const message = createBaseNotifySlackActionRequest();
    message.channel_ids = object.channel_ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseQnARequest(): QnARequest {
  return { questions: [] };
}

export const QnARequest: MessageFns<QnARequest> = {
  encode(message: QnARequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.questions) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): QnARequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQnARequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.questions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QnARequest {
    return {
      questions: globalThis.Array.isArray(object?.questions)
        ? object.questions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: QnARequest): unknown {
    const obj: any = {};
    if (message.questions?.length) {
      obj.questions = message.questions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QnARequest>, I>>(base?: I): QnARequest {
    return QnARequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QnARequest>, I>>(object: I): QnARequest {
    const message = createBaseQnARequest();
    message.questions = object.questions?.map((e) => e) || [];
    return message;
  },
};

function createBaseJobProto(): JobProto {
  return { header: undefined, request: undefined, job_run_headers: [] };
}

export const JobProto: MessageFns<JobProto> = {
  encode(message: JobProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.request !== undefined) {
      JobRequest.encode(message.request, writer.uint32(18).fork()).join();
    }
    for (const v of message.job_run_headers) {
      Header.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.request = JobRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.job_run_headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      request: isSet(object.request) ? JobRequest.fromJSON(object.request) : undefined,
      job_run_headers: globalThis.Array.isArray(object?.job_run_headers)
        ? object.job_run_headers.map((e: any) => Header.fromJSON(e))
        : [],
    };
  },

  toJSON(message: JobProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.request !== undefined) {
      obj.request = JobRequest.toJSON(message.request);
    }
    if (message.job_run_headers?.length) {
      obj.job_run_headers = message.job_run_headers.map((e) => Header.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobProto>, I>>(base?: I): JobProto {
    return JobProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobProto>, I>>(object: I): JobProto {
    const message = createBaseJobProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? JobRequest.fromPartial(object.request)
      : undefined;
    message.job_run_headers = object.job_run_headers?.map((e) => Header.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJobRunProto(): JobRunProto {
  return { header: undefined, job_header: undefined, steps: [], actions: [] };
}

export const JobRunProto: MessageFns<JobRunProto> = {
  encode(message: JobRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.job_header !== undefined) {
      Header.encode(message.job_header, writer.uint32(18).fork()).join();
    }
    for (const v of message.steps) {
      JobRunStep.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.actions) {
      JobRunStep.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.job_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.steps.push(JobRunStep.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actions.push(JobRunStep.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobRunProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      job_header: isSet(object.job_header) ? Header.fromJSON(object.job_header) : undefined,
      steps: globalThis.Array.isArray(object?.steps) ? object.steps.map((e: any) => JobRunStep.fromJSON(e)) : [],
      actions: globalThis.Array.isArray(object?.actions) ? object.actions.map((e: any) => JobRunStep.fromJSON(e)) : [],
    };
  },

  toJSON(message: JobRunProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.job_header !== undefined) {
      obj.job_header = Header.toJSON(message.job_header);
    }
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => JobRunStep.toJSON(e));
    }
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => JobRunStep.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobRunProto>, I>>(base?: I): JobRunProto {
    return JobRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobRunProto>, I>>(object: I): JobRunProto {
    const message = createBaseJobRunProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.job_header = (object.job_header !== undefined && object.job_header !== null)
      ? Header.fromPartial(object.job_header)
      : undefined;
    message.steps = object.steps?.map((e) => JobRunStep.fromPartial(e)) || [];
    message.actions = object.actions?.map((e) => JobRunStep.fromPartial(e)) || [];
    return message;
  },
};

function createBaseJobRunStep(): JobRunStep {
  return {
    analysis_step_index: undefined,
    db_content_index: undefined,
    id: undefined,
    type: undefined,
    name: undefined,
    input_tree_ids: [],
    analysis_step: undefined,
    analysis_plan_header: undefined,
    action_step: undefined,
    status: undefined,
    start_time_ms: undefined,
    end_time_ms: undefined,
    error: undefined,
    output: undefined,
  };
}

export const JobRunStep: MessageFns<JobRunStep> = {
  encode(message: JobRunStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.analysis_step_index !== undefined) {
      writer.uint32(8).int32(message.analysis_step_index);
    }
    if (message.db_content_index !== undefined) {
      writer.uint32(16).int32(message.db_content_index);
    }
    if (message.id !== undefined) {
      writer.uint32(26).string(message.id);
    }
    if (message.type !== undefined) {
      writer.uint32(32).int32(message.type);
    }
    if (message.name !== undefined) {
      writer.uint32(42).string(message.name);
    }
    for (const v of message.input_tree_ids) {
      writer.uint32(50).string(v!);
    }
    if (message.analysis_step !== undefined) {
      GenerateAnalysisTree_Request.encode(message.analysis_step, writer.uint32(58).fork()).join();
    }
    if (message.analysis_plan_header !== undefined) {
      Header.encode(message.analysis_plan_header, writer.uint32(66).fork()).join();
    }
    if (message.action_step !== undefined) {
      ActionRequest.encode(message.action_step, writer.uint32(74).fork()).join();
    }
    if (message.status !== undefined) {
      writer.uint32(80).int32(message.status);
    }
    if (message.start_time_ms !== undefined) {
      writer.uint32(88).int64(message.start_time_ms);
    }
    if (message.end_time_ms !== undefined) {
      writer.uint32(96).int64(message.end_time_ms);
    }
    if (message.error !== undefined) {
      writer.uint32(106).string(message.error);
    }
    if (message.output !== undefined) {
      writer.uint32(114).string(message.output);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JobRunStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJobRunStep();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.analysis_step_index = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.db_content_index = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.input_tree_ids.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.analysis_step = GenerateAnalysisTree_Request.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.analysis_plan_header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.action_step = ActionRequest.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.start_time_ms = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.end_time_ms = longToNumber(reader.int64());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.output = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JobRunStep {
    return {
      analysis_step_index: isSet(object.analysis_step_index)
        ? globalThis.Number(object.analysis_step_index)
        : undefined,
      db_content_index: isSet(object.db_content_index) ? globalThis.Number(object.db_content_index) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      type: isSet(object.type) ? jobRunStep_StepTypeFromJSON(object.type) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      input_tree_ids: globalThis.Array.isArray(object?.input_tree_ids)
        ? object.input_tree_ids.map((e: any) => globalThis.String(e))
        : [],
      analysis_step: isSet(object.analysis_step)
        ? GenerateAnalysisTree_Request.fromJSON(object.analysis_step)
        : undefined,
      analysis_plan_header: isSet(object.analysis_plan_header)
        ? Header.fromJSON(object.analysis_plan_header)
        : undefined,
      action_step: isSet(object.action_step) ? ActionRequest.fromJSON(object.action_step) : undefined,
      status: isSet(object.status) ? jobRunStep_RunStepStatusFromJSON(object.status) : undefined,
      start_time_ms: isSet(object.start_time_ms) ? globalThis.Number(object.start_time_ms) : undefined,
      end_time_ms: isSet(object.end_time_ms) ? globalThis.Number(object.end_time_ms) : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
      output: isSet(object.output) ? globalThis.String(object.output) : undefined,
    };
  },

  toJSON(message: JobRunStep): unknown {
    const obj: any = {};
    if (message.analysis_step_index !== undefined) {
      obj.analysis_step_index = Math.round(message.analysis_step_index);
    }
    if (message.db_content_index !== undefined) {
      obj.db_content_index = Math.round(message.db_content_index);
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.type !== undefined) {
      obj.type = jobRunStep_StepTypeToJSON(message.type);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.input_tree_ids?.length) {
      obj.input_tree_ids = message.input_tree_ids;
    }
    if (message.analysis_step !== undefined) {
      obj.analysis_step = GenerateAnalysisTree_Request.toJSON(message.analysis_step);
    }
    if (message.analysis_plan_header !== undefined) {
      obj.analysis_plan_header = Header.toJSON(message.analysis_plan_header);
    }
    if (message.action_step !== undefined) {
      obj.action_step = ActionRequest.toJSON(message.action_step);
    }
    if (message.status !== undefined) {
      obj.status = jobRunStep_RunStepStatusToJSON(message.status);
    }
    if (message.start_time_ms !== undefined) {
      obj.start_time_ms = Math.round(message.start_time_ms);
    }
    if (message.end_time_ms !== undefined) {
      obj.end_time_ms = Math.round(message.end_time_ms);
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    if (message.output !== undefined) {
      obj.output = message.output;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JobRunStep>, I>>(base?: I): JobRunStep {
    return JobRunStep.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JobRunStep>, I>>(object: I): JobRunStep {
    const message = createBaseJobRunStep();
    message.analysis_step_index = object.analysis_step_index ?? undefined;
    message.db_content_index = object.db_content_index ?? undefined;
    message.id = object.id ?? undefined;
    message.type = object.type ?? undefined;
    message.name = object.name ?? undefined;
    message.input_tree_ids = object.input_tree_ids?.map((e) => e) || [];
    message.analysis_step = (object.analysis_step !== undefined && object.analysis_step !== null)
      ? GenerateAnalysisTree_Request.fromPartial(object.analysis_step)
      : undefined;
    message.analysis_plan_header = (object.analysis_plan_header !== undefined && object.analysis_plan_header !== null)
      ? Header.fromPartial(object.analysis_plan_header)
      : undefined;
    message.action_step = (object.action_step !== undefined && object.action_step !== null)
      ? ActionRequest.fromPartial(object.action_step)
      : undefined;
    message.status = object.status ?? undefined;
    message.start_time_ms = object.start_time_ms ?? undefined;
    message.end_time_ms = object.end_time_ms ?? undefined;
    message.error = object.error ?? undefined;
    message.output = object.output ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
